import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'UiActionButton',
  props: {
    variant: {
        type: String,
        default: 'neutral',
    },
    to: {
        type: Object,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createBlock(_component_UiButton, {
    variant: "inherit",
    "text-variant": __props.variant,
    "ring-variant": __props.variant,
    "no-border": "",
    "no-shadow": "",
    "no-padding": "",
    "no-rounded": "",
    class: "rounded-full text-sm",
    to: __props.to
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["text-variant", "ring-variant", "to"]))
}
}

})